export const topbar = {
    type: "nested",
    label: "Topbar Config",
    fields: {
        showMenu: {
            type: "boolean",
            label: "Show Menu"
        },
        shortHeader: {
            type: "boolean",
            label: "Short Header"
        },
        maxWidth: {
            type: "text",
            label: "Max Width"
        }
    }
};
